export default __webpack_public_path__ + "static/media/mamut_m1.86375323.png";